<template>
  <div id="pad">
    <p id="pad-handle">
      Notes <a :href="url" target="_blank">(↗)</a>
    </p>
    <div id="pad-content">
      <iframe name="embed_readwrite" :src='url + "?showControls=false&showChat=false&showLineNumbers=true&useMonospaceFont=true?noColors=true?chatAndUsers=false"' width="100%" height="600" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
import interactions from "../interactions";

export default {
  name: "Pad",
  data() {
    return {
      x: null,
      y: null,
      fold: false,
      ratioLock: false
    }
  },
  props: ['url'],
  mounted() {
    interactions.dragDropResize(
      "#pad",
      "#pad-handle",
      "#pad-content",
      this.x,
      this.y
    );
    interactions.enableFold("#pad-handle", "#pad-content", this.fold);
  }
}
</script>

<style>
#pad p {
  border-bottom: var(--default-border);
  top: 0;
  font-size: 16px;
  margin-block-start: 0;
  padding: 5px;
}

#pad-content {
  height: 20vh;
  width:200px;
  overflow-y: auto;
}

#pad-handle a {
  line-height:1;
}

#pad {
  position: absolute;
  margin-top: 409px;
  z-index: 1000;
  max-height: max-content;
}

#pad #pad-handle {
  margin: 0;
  overflow:hidden;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

#pad-content {
  height: 20vh;
  width:200px;
  overflow-y: auto;
}

#pad-content > iframe {
  position:relative;
  width:100%;
  height:98%;
  filter: none;
}

</style>